import React, { FC, useMemo } from "react";
import StatusDialog, { StatusDialogProps } from "../../Unknown/StatusDialog";
import Typography from "../../Unknown/Typography";
import useTranslations from "./useTranslations";

export type AppointmentReportResendDialogProps = {
  isOpened: boolean;
  patientFirstName: string;
  patientLastName: string;
  patientEmail: string;
  isLoading?: boolean;
  errorMessage?: string | null;
  handleClose: () => void;
  handleSubmit: () => void | Promise<void>;
};

const AppointmentReportResendDialog: FC<AppointmentReportResendDialogProps> = ({
  isOpened,
  patientFirstName,
  patientLastName,
  patientEmail,
  isLoading,
  errorMessage,
  handleClose,
  handleSubmit,
}) => {
  const { translations } = useTranslations();

  const actionButtons = useMemo<StatusDialogProps["actionButtons"]>(() => {
    return [
      {
        text: translations.btnCancel,
        key: "cancel",
        onClick: handleClose,
        disabled: isLoading,
      },
      {
        text: translations.btnSubmit,
        key: "submit",
        onClick: handleSubmit,
        color: "primary",
        disabled: isLoading || !!errorMessage,
      },
    ];
  }, [
    errorMessage,
    handleClose,
    handleSubmit,
    isLoading,
    translations.btnCancel,
    translations.btnSubmit,
  ]);

  return (
    <StatusDialog
      open={isOpened}
      title={translations.title}
      isLoading={isLoading}
      errorMessage={errorMessage}
      actionButtons={actionButtons}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          maxWidth: 500,
        },
      }}
    >
      <Typography>
        {translations.message}{" "}
        <Typography component="span" fontWeight={600}>
          {patientFirstName} {patientLastName}
        </Typography>{" "}
        {translations.at}{" "}
        <Typography component="span" fontWeight={600}>
          {patientEmail}
        </Typography>
      </Typography>
    </StatusDialog>
  );
};

export default AppointmentReportResendDialog;
